import React from 'react'
import Link  from 'next/link';
import videowall from '../public/Pictures/category-videowall.jpg'
import stage from '../public/Pictures/stage_b1.jpg'
import sound from '../public/Pictures/sound-sys-b.jpg'
import lighting from '../public/Pictures/lighting-a.jpg'
import projector from '../public/Pictures/tv-a.jpg'
import effects from '../public/Pictures/category-effects.jpg'
import karaoke from '../public/Pictures/category-karaoke.jpg'
import djequipment from '../public/Pictures/dj-equip-a.jpg'
import djequipment_icon from '../public/Pictures/dj-equipment-icon.png'
import staging_icon from '../public/Pictures/staging-icon.png'
import lighting_icon from '../public/Pictures/lighting-icon.png'
import sound_icon from '../public/Pictures/sound-icon.png'
import visuals_icon from '../public/Pictures/visuals-icon.png'
import special_effects_icon from '../public/Pictures/special-effects-icon.png'
import homepageSound from '../public/Pictures/categories-v2/sound-systems.jpg'
import homepageVisuals from '../public/Pictures/categories-v2/visuals.jpg'
import homepageStaging from '../public/Pictures/categories-v2/staging.jpg'
import homepageDjEquipment from '../public/Pictures/categories-v2/dj-equipment.jpg'
import homepageLighting from '../public/Pictures/categories-v2/lighting.jpg'
import homepageSpecialEffects from '../public/Pictures/categories-v2/special-effects.jpg'
import PicCont from './PicCont';
import LinkWrap from './LinkWrap';
import { AiOutlineCaretRight } from "@react-icons/all-files/ai/AiOutlineCaretRight";
import AudioAction from './design-system/audio/AudioAction';
import LandingCategoriesV2 from './design-system/marketing/LandingCategoriesV2';
import ServiceCategoryGrid from './design-system/marketing/ServiceCategoryGrid';
import MarketingIsland from './design-system/marketing/MarketingIsland';

const LandingCategories = ({ filter, blank, selected, options, category, white, title, className, orlando, priority, loading, ui, homepage, eyebrow, heading, description }) => {

  let _orlando = Boolean(orlando)

    let categories = [
        {
            name:'Sound Systems',
            picture: sound,
            homepagePicture: homepageSound,
            icon: sound_icon,
            cat: 'sound',
            sub: 'Only PRO Audio Equipment for High-Quality Sound.',
            main: `https://miamisoundrental.com/sound-system-rental`,
            subCats: [
                {
                    name: 'Speaker Rentals',
                    link:`https://miamisoundrental.com/${_orlando? 'orlando/': ''}speaker-rental`,
                },
                {
                    name: 'Microphone Rentals',
                    link:'https://miamisoundrental.com/microphone-rental',
                },
                {
                    name: 'Karaoke Machine Rental',
                    link:`https://miamisoundrental.com/${_orlando? 'orlando/': ''}karaoke-rental`,
                },
            ]
        },

        {
            name:'Visuals',
            picture: projector,
            homepagePicture: homepageVisuals,
            icon: visuals_icon,
            cat: 'visuals',
            sub: 'Visual Equipment, from small TVs to Video Walls',
            main: `https://miamisoundrental.com/visuals`,
            subCats: [
                {
                    name: 'Video Wall Rental',
                    link:`https://miamisoundrental.com/${_orlando? 'orlando/': ''}led-video-wall-rental`,
                },
                {
                    name: 'Projector & Screen Rentals',
                    link:`https://miamisoundrental.com/${_orlando? 'orlando/': ''}projector-rental`,
                },
                {
                    name: 'TV Rentals',
                    link:`https://miamisoundrental.com/${_orlando? 'orlando/': ''}tv-rental`,
                },

            ]
        },

        // {
        //     name:'LED Video Wall Displays',
        //     picture: videowall,
        //     subCats: [

        //         {
        //             name: 'LED Panels Rental',
        //             link:'https://miamisoundrental.com/led-video-wall-rental',
        //         },

        //     ]
        // },
        {
            name:'Staging',
            picture: stage,
            homepagePicture: homepageStaging,
            icon: staging_icon,
            cat: 'staging',
            sub: 'Build your custom stage or rent a premade stage package.',
            main: `https://miamisoundrental.com/${_orlando? 'orlando/': ''}stage-rental`,
            subCats: [
                {
                    name: 'Stage Rental',
                    link:`https://miamisoundrental.com/${_orlando? 'orlando/': ''}stage-rental`,
                },
                {
                    name: 'Truss Rentals',
                    link:'https://miamisoundrental.com/staging/truss',
                },
                {
                    name: 'Pipe and Drape',
                    link:'https://miamisoundrental.com/staging/drape',
                },

            ]
        },
        {
            name:'DJ Equipment',
            picture: djequipment,
            homepagePicture: homepageDjEquipment,
            icon: djequipment_icon,
            cat: 'dj_equipment',
            sub: 'Professional DJ Equipment. DJ Mixers, Controllers and CDJs',
            main: `https://miamisoundrental.com/${_orlando? 'orlando/': ''}dj-equipment-rental`,
            subCats: [
                {
                    name: 'DJ Mixer Rentals',
                    link:'https://miamisoundrental.com/dj-equipment/mixers',
                },
                {
                    name: 'CDJs Rentals',
                    link:'https://miamisoundrental.com/dj-equipment/cdjs',
                },
                {
                    name: 'DJ Controllers Rentals',
                    link:'https://miamisoundrental.com/dj-equipment/controller',
                },
            ]
        },
        {
            name:'Lighting',
            picture: lighting,
            homepagePicture: homepageLighting,
            icon: lighting_icon,
            cat: 'lighting',
            sub: 'Stage & DJ lighting for your event. Spotlights, Uplighting, & Moving Heads.',
            main: `https://miamisoundrental.com/lighting-rental`,
            subCats: [
                {
                    name: 'Uplighting Rentals',
                    link:'https://miamisoundrental.com/lighting/up-lighting',
                },
                {
                    name: 'Spotlight Rentals',
                    link:'https://miamisoundrental.com/lighting/spotlight',
                },
                {
                    name: 'Moving Heads',
                    link:'https://miamisoundrental.com/lighting/moving-heads',
                },


            ]
        },
        // {
        //     name:'Karaoke',
        //     picture: karaoke,
        //     subCats: [



        //     ]
        // },
        {
            name:'Special Effects',
            picture: effects,
            homepagePicture: homepageSpecialEffects,
            icon: special_effects_icon,
            cat: 'special_effects',
            sub: 'Special Effects to wow your guests. CO2 Cannons, Cold Sparks and more.',
            main: `https://miamisoundrental.com/special-effects`,
            subCats: [
                {
                    name: 'Cold Spark Rental',
                    link:'https://miamisoundrental.com/special-effects/cold-sparks',
                },
                {
                    name: 'CryoGun / CO2 Cannon Rental',
                    link:'https://miamisoundrental.com/special-effects/co2-cannon',
                },
                {
                    name: 'Fog Machine Rental',
                    link:'https://miamisoundrental.com/special-effects/fog-machine',
                },


            ]
        },
    ]


  if (ui === 'v2' && homepage) {
    return <MarketingIsland>
      <LandingCategoriesV2
        categories={categories}
        description={description}
        eyebrow={eyebrow}
        heading={heading}
        loading={loading}
        priority={priority}
        title={title}
      />
    </MarketingIsland>
  }

  if (ui === 'v2') {
    return <MarketingIsland>
      <ServiceCategoryGrid
        currentCategory={category && category !== 'none' ? category : null}
        description={description}
        eyebrow={eyebrow}
        heading={heading}
        orlando={_orlando}
      />
    </MarketingIsland>
  }

  return  <section id='categories' className={`landingCategories ${options ? 'optionCards' : ''} ${className} ${white ? 'white' : ''}`}>
  {title && <div className='title upperBold'>Explore our AV categories</div>}
    <div className='row'>
        {categories.map((c,i) => <div key={i} className={`categoryCard ${options ? 'optionCard' : ''} ${category && c.cat !== category ? 'faded' : ''} ${selected && selected !== c.cat ? 'faded' :''} ${filter ? blank ? 'maxClick' : 'miniClick':''}`} onClick={filter ? () => filter(c.cat) : null} >
            {ui === 'v2' && options ? <AudioAction mode='card' href={c.main} className='card short blackgrad' wrapContent={false}>
           {!options &&    <PicCont priority={priority} loading={loading}  width={200} height={200}  src={c.icon} /> }

            {!options &&    <div className="back"></div>}
                <div className="textCont">
                {options && <PicCont priority={priority} loading={loading}  width={200} height={200}  src={c.icon} />  }
                    <h3 className='upperBold'>{c.name}</h3>
                    {c.sub && <p className='thick'>{c.sub}</p>}

                </div>
            </AudioAction> : ui === 'v2' ? <div className='card short blackgrad'>
           {!options &&    <PicCont priority={priority} loading={loading}  width={200} height={200}  src={c.icon} /> }

            {!options &&    <div className="back"></div>}
                <div className="textCont">
                {options && <PicCont priority={priority} loading={loading}  width={200} height={200}  src={c.icon} />  }
                    <h3 className='upperBold'>{c.name}</h3>
                    {c.sub && <p className='thick'>{c.sub}</p>}

                </div>
            </div> : <LinkWrap disabled={!options} href={c.main} className='card short blackgrad'>
           {!options &&    <PicCont priority={priority} loading={loading}  width={200} height={200}  src={c.icon} /> }

            {!options &&    <div className="back"></div>}
                <div className="textCont">
                {options && <PicCont priority={priority} loading={loading}  width={200} height={200}  src={c.icon} />  }
                    <h3 className='upperBold'>{c.name}</h3>
                    {c.sub && <p className='thick'>{c.sub}</p>}

                </div>
            </LinkWrap>}
       {!filter && <div className="box">

            {c.subCats.map((sc, y) => ui === 'v2'
              ? <AudioAction mode='text' key={y} href={sc.link}>{sc.name}</AudioAction>
              : <LinkWrap key={y} href={sc.link} >{sc.name}</LinkWrap>)}
            {ui === 'v2'
              ? <AudioAction mode='text' className='bottom' key={c.name} href={c.main}>View All {c.name} Rentals <AiOutlineCaretRight /></AudioAction>
              : <LinkWrap className='bottom' key={c.name} href={c.main} >View All {c.name} Rentals <AiOutlineCaretRight />  </LinkWrap>}
        </div>}
        </div>)}
    </div>
    </section>


}

export default LandingCategories
